// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__SanvA","additionalInfo":"AgreementModal_additionalInfo__vWSsV"};